import React from 'react'
import t from 'prop-types'
import cx from 'classnames'

const StatSmall = ({ isOnDarkBg, label, pct }) => {
  return (
    <div className="flex items-center">
      <div
        className={cx(
          'text-2xl md:text-3xl font-serif leading-none font-bold',
          {
            'text-gray-700': !isOnDarkBg,
            'text-gray-200': isOnDarkBg,
          }
        )}
      >
        {pct}
      </div>
      <div
        className={cx(
          'ml-3 text-xs md:text-sm lg:text-base leading-tight tracking-widest lg:tracking-wider uppercase font-medium',
          {
            'text-gray-600': !isOnDarkBg,
            'text-gray-200': isOnDarkBg,
          }
        )}
      >
        {label}
      </div>
    </div>
  )
}

StatSmall.propTypes = {
  isOnDarkBg: t.bool,
  label: t.string,
  pct: t.string,
}

StatSmall.defaultProps = {
  isOnDarkBg: false,
}

export default StatSmall
